import vuetify from "@/main";
import FixedFeesPage from "./FixedFeesPage.vue";
angular.module("leanlaw").config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("fixedfees", {
    url: "/fixedfees?chargeId&matterId&modal&panel",
    ...vuetify(FixedFeesPage),
    params: {
      chargeId: {
        value: null,
        squash: true
      },
      matterId: {
        value: null,
        squash: true
      },
      modal: {
        value: null,
        squash: true
      },
      panel: {
        value: null,
        squash: true
      },
      fixedFeeTemplate: {
        value: false
      },
      ledes: {
        value: false
      },
      showAllocation: {
        value: false
      }
    }
  });
}]);